// extracted by mini-css-extract-plugin
export default {"container":"CategoryTabs_container__uhmDP","btn":"CategoryTabs_btn__uJ8Vn","dead":"CategoryTabs_dead__4tO3o"};